import { createIcon } from '../../icon';

import AsteriskSvg from './asterisk.svg';

export const AsteriskIcon = createIcon(AsteriskSvg, 'AsteriskIcon');
